import { render } from "./qlc-header.vue?vue&type=template&id=2511b4da&scoped=true"
import script from "./qlc-header.vue?vue&type=script&lang=js"
export * from "./qlc-header.vue?vue&type=script&lang=js"

import "./qlc-header.vue?vue&type=style&index=0&id=2511b4da&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2511b4da"]])

export default __exports__